import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';
import { APP_ZONES, NavigationOptionEnum } from '../workflow.type';
import { DummyRole } from '../workflow.v2.type';

export const accountNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map([
  [
    ButtonActionType.SAVE_SPENDING_BUDGET,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        ...defaultNavigationConfig,
        selectedNavigationOption: NavigationOptionEnum.USE_AS_BLANK,
      },
      [ActionButtonOutcomesType.FAILURE]: {
        ...defaultNavigationConfig,
        selectedNavigationOption: NavigationOptionEnum.USE_AS_BLANK,
      },
    },
  ],
  [
    ButtonActionType.DEACTIVATE_LEDGER_ACCOUNT,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: {
        selectedZone: APP_ZONES.ACCOUNTS_ZONE,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'account-credentials',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
  [
    ButtonActionType.REVIEW_ACCOUNT_REQUESTS,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PROFILE,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'sumsub',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
      [ActionButtonOutcomesType.ALTERNATE_1]: {
        selectedZone: APP_ZONES.LANDING,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'review-account-requests',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
    },
  ],
]);
